import { AddAccount } from '@unistocks/features/external-accounts/add-account';
import { t } from '@unistocks/localization';
import Head from 'expo-router/head';
import * as WebBrowser from 'expo-web-browser';

WebBrowser.maybeCompleteAuthSession();

export default function AddAccountScreen() {
  return (
    <>
      <Head>
        <title>{t('::ExternalAccounts:AddAccount')}</title>
      </Head>
      <AddAccount />
    </>
  );
}
